var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    fill: "#8CA1B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95241 7.00959H6.02912V6.913C6.0348 6.35902 6.23366 6.1005 6.68253 5.83061C7.21378 5.51527 7.56037 5.09766 7.56037 4.43004C7.56037 3.43572 6.75923 2.85618 5.63139 2.85618C4.60014 2.85618 3.75923 3.39595 3.73366 4.53232H4.89276C4.9098 4.06925 5.25355 3.82209 5.62571 3.82209C6.00923 3.82209 6.31889 4.07777 6.31889 4.47266C6.31889 4.84482 6.04901 5.09197 5.69957 5.31357C5.2223 5.6147 4.95526 5.91868 4.95241 6.913V7.00959ZM5.51207 8.82777C5.87571 8.82777 6.19105 8.52379 6.19389 8.14595C6.19105 7.77379 5.87571 7.46982 5.51207 7.46982C5.13707 7.46982 4.82741 7.77379 4.83026 8.14595C4.82741 8.52379 5.13707 8.82777 5.51207 8.82777Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpGray);
export default __webpack_public_path__ + "static/media/help-gray.e25e1e1bb136c77a315c29a526eae4a4.svg";
export { ForwardRef as ReactComponent };